import { useSelector } from 'react-redux';
import Price from '../../../../Assets/icons/price.svg'

function OrganizationCost({cost}) {

    const {consumer} = useSelector(state => state.auth)

    function costCoins () {
        const coins = []
        if(cost && cost > 0) {
            for(let i=1; i<=cost; i++) {
                coins.push(<img src={Price} key={i} alt="icon" />)
            }
            return coins;
        }
    }
    
    return (
        <>
            <p>
                {
                    consumer
                    ?
                        consumer.language === 'english'
                        ?
                            'Cost'
                        :
                            'খরচ পরিসীমা:'
                    :
                        'খরচ পরিসীমা:'
                }
            </p>
            {costCoins()}
        </>
    )
}

export default OrganizationCost